import { IAuthContext } from "@/interfaces"
import { ICategoryItem, IListItems } from "@/interfaces/components"
import { ContextActions } from "@/types/context"
import { currentTheme } from "@/utils/currentTheme"
import { User } from "firebase/auth"
import firebase from "firebase/compat/app"
import { createContext, Dispatch, useContext } from "react"

const context: IAuthContext = {
  user: {} as User,
  accessToken: "",
  metadata: {},
  loading: "idle",
  isUser: false,
  theme: currentTheme(),
  listCategory: [] as ICategoryItem[],
  listGroups: [] as IListItems[],
  groupBdId: "",
}

export const AuthContext = createContext<{
  context: IAuthContext
  dispatch: Dispatch<ContextActions>
}>({
  context,
  dispatch: (action: ContextActions) => action,
})
export const useGlobalContext = () => {
  return useContext(AuthContext)
}
